import { useGate, useUnit } from 'effector-react'
import {
  $players,
  $teamOptions,
  getPlayersFx,
  getTeamsFx,
  PlayerListGate,
} from 'src/pages/worldCup2026/players/model'

export const usePlayerListGate = () => useGate(PlayerListGate)

export const useTeamOptions = () => {
  const loadingTeams = useUnit(getTeamsFx.pending)
  const teamOptions = useUnit($teamOptions)

  return { loadingTeams, teamOptions }
}

export const usePlayerList = () => {
  const players = useUnit($players)
  const loadingPlayers = useUnit(getPlayersFx.pending)

  return { players, loadingPlayers }
}
